import { useEffect } from 'react'
import { useLocalObservable } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CallingStore } from 'pages/chatbot/pages/calling/pages/index/store/CallingStore.ts'
import { useListLayoutContext } from 'pages/chatbot/layout/ListLayout/context'
import { CallingUI } from './ui/CallingUI'
import { CallingContext } from './context'

export const Calling = () => {
  const listLayoutStore = useListLayoutContext()
  const entities = useEntitiesContext()
  const callingStore = useLocalObservable(() => new CallingStore(entities, listLayoutStore))
  useEffect(callingStore.init, [])
  return (
    <CallingContext.Provider value={callingStore}>
      <CallingUI />
    </CallingContext.Provider>
  )
}
